import React from 'react'
// import Label from '../control-label'
import FontItems from './font-items'
import IconButton from 'Components/icon-button';
import PopoverDetectOutside from 'Components/popover/detect-outside';
// import detectClickOutside from 'react-click-outside';
import { __ } from 'StylistParent/i18n';
// import Tooltip from '../../../tooltip'

/* Import CSS */
import './index.scss'

class FontSelector extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			fontSelectorOpen: false,
		}
	}

	changeValue = ( newValue ) => {
		// Send value up to the parent component (Control).
		this.props.changeValue( newValue )
	}

	onInputChange = ( event ) => {
		this.changeValue( event.target.value )
	}

	onFontSelected = ( font ) => {
		console.log( "onFontSelected:" );
		console.log( font );
		this.toggleFontSelector()

		if ( undefined !== font.family ) {
			// Send value up to the parent component (Control).
			this.changeValue( font.family )
			this.input.value = font.family
		}
	}

	toggleFontSelector = () => {
		this.setState( {
			fontSelectorOpen: ! this.state.fontSelectorOpen,
		} )
	}

	render() {
		return (
			<div className="stlst-font-control">
				<input type="text"
					// className='stlst-after-css stlst-after-css-val'
					autoComplete="off"
					defaultValue={ this.props.value }
					// value={parseInt(value)}
					onChange={ this.onInputChange }
					ref={( input ) => this.input = input}
					style={ { fontFamily: this.props.value } } />

				<IconButton
					onClick={ this.toggleFontSelector }
					icon="translation"
					label={ __( 'Select Font' ) }
				/>

				{ this.state.fontSelectorOpen &&
					<PopoverDetectOutside
						onClickOutside={ this.toggleFontSelector }>
						<FontItems
							onFontSelected={this.onFontSelected}
							toggleFontSelector={this.toggleFontSelector}
						/>
					</PopoverDetectOutside> }
			</div>
		)
	}
}

export default FontSelector;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/font-selector/index.jsx